var map = {
	"./img_0.png": 487,
	"./img_1.png": 488,
	"./img_2.png": 489,
	"./img_3.png": 490,
	"./img_4.png": 491,
	"./img_5.png": 492,
	"./img_6.png": 493,
	"./img_7.png": 494,
	"./img_8.png": 495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;